module.exports = __webpack_public_path__ + "img/React.001141fd.png";